const extractPlaybackUrl = (data = {}, config = {}) => {

    let playbackUrl = '';
    const playbacks = data.playbacks ?? [];
    const playbackScenarios = config.player?.mediaConfig?.global?.preferredPlaybackScenarios ?? [];

    /** pick playback format by preferred scenario */
    playbackScenarios.some(playbackScenario => {

        let playback = playbacks.find(playback => playback.name === playbackScenario);
        if (playback) {

            playbackUrl = playback?.url;

        }
        return playback;

    });

    return playbackUrl;

};

export default extractPlaybackUrl;
